import useEmblaCarousel from 'embla-carousel-react';
import React, { useEffect } from 'react'
import {ReactComponent as IcQuote} from '../../assets/icons/quote.svg'
import {ReactComponent as IcUser} from '../../assets/icons/user.svg'
import {ReactComponent as IcStar} from '../../assets/icons/star.svg'
import  data  from '../../data/staticData'



export const Testimonials = () => {
      const [emblaRef, embla] = useEmblaCarousel({ loop: true, align: "start", direction:'ltr' });
      useEffect(() => {
        if (!embla) return;
    
        const autoplay = setInterval(() => {
            embla.scrollNext();
        }, 3000);
    
        return () => clearInterval(autoplay);
      }, [embla]);
    return(
        <div>
           <div className="text-left p-14">
                <h2 className="text-base text-[#548CA8]">Testimonials</h2>
                <h6 className="font-semibold text-xl">Apa Kata Pelanggan Kami</h6>
           </div>
           <div className="overflow-hidden h-72 md:h-96" ref={emblaRef}>
                <div className="flex gap-4">
                    {data.testimoni.map((item, index) => (
                        <div
                            key={index}
                            className="min-w-[400px] text-base grid gap-3 bg-gray-50 border border-gray-100 rounded-lg shadow-md p-4 text-left"
                        >
                            <IcQuote />
                            <p className="text-sm text-gray-600">{item.testimoni}</p>
                            <div className="flex w-full items-center space-x-2">
                                <div className="bg-[#548CA8] rounded-full w-fit p-1">
                                    <IcUser />
                                </div>
                                <div className="flex w-full justify-between">
                                    <p className=''>{item.customer}</p>
                                    <div className="flex">
                                        {Array(item.stars).fill("").map((index) => (
                                            <IcStar key={index} />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}